<template>
  <div id="container">
    <v-dialog v-model="value" max-width="300" persistent>
      <v-card style="text-align:center">
        <v-icon x-large class="py-2" color="success">done</v-icon>
        <v-card-title
          class="center_btns"
          style="font-weight:700; font-size:17px"
          primary-title
        >
          {{ description }}
        </v-card-title>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: ['value', 'description'],
  watch: {
    value() {
      if (this.value) {
        var v = this
        setTimeout(() => {
          v.close()
        }, 2000)
      }
    },
  },
  components: {},
  data() {
    return {}
  },

  methods: {
    close() {
      this.$emit('input', !this.value)
    },
  },
  computed: {},
}
</script>

<style scoped>
.center_btns {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
}
</style>
